import { render, staticRenderFns } from "./ViewerFooterDesign.vue?vue&type=template&id=3b5e5c23&scoped=true"
import script from "./ViewerFooterDesign.vue?vue&type=script&lang=js"
export * from "./ViewerFooterDesign.vue?vue&type=script&lang=js"
import style0 from "./ViewerFooterDesign.vue?vue&type=style&index=0&id=3b5e5c23&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b5e5c23",
  null
  
)

export default component.exports